module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_BlackMatted.5a2bf01c.jpg";